var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6251 3.37501V20.6175H3.37508V3.37501H20.6176M22.3576 1.63501H1.64258V22.35H22.3576V1.64251V1.63501ZM11.5276 14.04L16.3426 9.08251L15.3751 8.08501L10.5601 13.0425L8.62508 11.0625L7.65758 12.06L9.59258 14.04L10.5601 15.0375L11.5276 14.04Z",
    fill: "#2A2859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessSquare);
export default __webpack_public_path__ + "static/media/success-square.69374244.svg";
export { ForwardRef as ReactComponent };